import React from 'react';

const SectionTitle = ({ title, subtitle }) => {
    return (
        <div className="section_title">
            <h1>{title}</h1>
            <p>{subtitle}</p>
        </div>
    );
};

export default SectionTitle;